import type { RiskSignals } from '../hooks/use-risk-signals';

const PAYMENT_TYPE_CODE = 'pix-jsr';
const OPERATION_ENROLLMENT = 'hosted_enrollment_register';
const COUNTRY_CODE_BR = 'br';
const IDENTIFICATION_TYPE_CPF = 'cpf';
const FIDO_PLATFORM_BROWSER = 'BROWSER';

interface BuildEnrollmentPayloadParams {
  readonly contract: string;
  readonly cpf: string;
  readonly bankId: string;
  readonly riskSignals: RiskSignals;
}

interface EnrollmentPayload {
  readonly contract: string;
  readonly payment_type_code: string;
  readonly operation: string;
  readonly enrollment: {
    readonly country: string;
    readonly notification_url: string;
    readonly identification_type: string;
    readonly identification: string;
    readonly account_details: {
      readonly bank_id: string;
    };
    readonly fidoOptions: {
      readonly platform: string;
      readonly risk_signals: RiskSignals;
    };
  };
}

export function buildEnrollmentPayload({
  contract,
  cpf,
  bankId,
  riskSignals,
}: BuildEnrollmentPayloadParams): EnrollmentPayload {
  return {
    contract,
    payment_type_code: PAYMENT_TYPE_CODE,
    operation: OPERATION_ENROLLMENT,
    enrollment: {
      country: COUNTRY_CODE_BR,
      notification_url: '',
      identification_type: IDENTIFICATION_TYPE_CPF,
      identification: cpf.replace(/\D/g, ''),
      account_details: {
        bank_id: bankId,
      },
      fidoOptions: {
        platform: FIDO_PLATFORM_BROWSER,
        risk_signals: riskSignals,
      },
    },
  };
}
